import styled from "styled-components";
import ActionButton from "../../../components/Button/ActionButton";
import { NavLink } from "react-router-dom";

interface IProps {
    isOpen: boolean;
};

export default function Auth401({ isOpen }: IProps) {
    if (!isOpen) {
        return null;
    }

    return (
        <Container>
            <Content>
                <h2>Sessão Expirada</h2>
                <p>Sua sessão expirou. Por favor, faça login novamente.</p>
                <NavLink to={'/'} className='nav'>
                    <ActionButton name='Login' />
                </NavLink>
            </Content>
        </Container>
    );
}

const Container = styled.div`
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
    background-color: rgb(0,0,0, 0.2);

    display: flex;
    align-items: center;
    justify-content: center;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    padding: 36px 28px;

    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;

    -webkit-box-shadow: 7px 8px 29px -16px ${(props) => props.theme.colors.gray.gray_200};
    -moz-box-shadow: 7px 8px 29px -16px ${(props) => props.theme.colors.gray.gray_200};
    box-shadow: 7px 8px 29px -16px ${(props) => props.theme.colors.gray.gray_200};

    .nav{
        display: flex;
        justify-content: flex-end;
        text-decoration: none;
    }


    @media (max-width: 700px) {
        width: 90%;
    }
`;